import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  // myfont: {
  //   "& .mantine-1fzet7j": {
  //     fontFamily: "Inter !important",
  //     fontWeight: "400 !important",
  //     color: "#263238 !important",
  //   },
  // },
  healthFormContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    gap: "6rem",
  },
  healthDropdowns: {
    margin: "1rem 0",
  },

  healthdflex: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
    marginTop:'28px',
    width:'100%',
    // justifyContent: "space-between",
    // gap: "20px",
    gap: "16px",
    // justifyContent: "flex-end",

    "@media (max-width:950px)": {
      flexDirection: "column",
      marginBottom: "20px",
      marginTop: "20px",
      gap: "10px",
    },
  },


    healthwidthbox: {
    width: "100% !important",
  },
    healthfullw: {
    width: "100% !important",
  },

    healthsearchbox: {
    //  marginTop: "10px",
   
    width:'100%'
  },

  lookupflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },


    healthcontainer: {
    display: "flex",
    flexDirection: "column",
    // gap: "6px",
    width: "100%",
  },
  healthboxWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    padding: "5px 15px",
    backgroundColor: "#fff",
    width: "100%",
  },
  healthselectBilling: {
    width: "65px",
    minWidth: "65px",
    fontSize: "14px",
  },

  healthtableheader: {
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#000 !important",
  },

  healthinputField: {
    flex: 1,
    fontSize: "14px",
    border: "none",
    padding: "0",
  },

    healthgap: {
    display: "flex",
    gap: "8px",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "19px",
    width:'100%',

    "@media (max-width:1370px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },

  diagnosis: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: "10px",
  },
  tags: {
    // width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexWrap: "wrap",
    position: "relative",
  },
  diagnosisTags: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginTop: "1.5rem",
    flexWrap: "wrap",
    background: "#6C63FF1A",
    color: "#6C63FF",
  },
  allergiesTags: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginTop: "1.5rem",
    flexWrap: "wrap",
    background: "#1DA7061A",
    color: "#167207",
  },
  dietariesTag: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginTop: "1.5rem",
    flexWrap: "wrap",
    background: "#FF5E031A",
    color: "#FF5E03",
  },
  close: {
    position: "absolute",
    top: "7px",
    right: "-12px",
    width: "30px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "24px",
    // zIndex: "1000",
  },
  formField: {
    marginTop: 30,
  },
  imgUploadBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  imgUpload: {
    cursor: "pointer",
    width: "111px",
    height: "111px",
  },
  loaderBox: {
    width: "111px",
    height: "111px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  select: {
    background: "#f1f3f5",
    padding: "0 5px",
  },
  heightWidthInput: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "100%",
  },
  textInputBox: {
    width: "100%",
    marginTop: "10px",
    border: "1px solid rgba(0,0,0,0.1)",
    padding: "5px 15px",
    borderRadius: "15px",
    position: "relative",
    "& textarea[disabled]": {
      backgroundColor: "#fff !important",
    },
    "& .mantine-Textarea-input": {
      border: "none",
      paddingInline: "0",
    },
    "& .label": {
      position: "absolute",
      top: -10,
      left: 15,
      zIndex: 100,
      margin: 0,
      color: "#5C5C5C",
      backgroundColor: "#fff",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: 500,
      paddingInline: "10px",
    },
  },
  inputLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  },
  btns: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "100%",
    margin: "auto",
    marginTop: 25,
    marginBottom: 10,
  },
  centerBTN: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  allergiesDietaryInput: {
    width: "270px",
  },
  labelCheck: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: "10px",
    marginTop: "10px",
  },

  drop: {
    display: "none",
    "& .mantine-Image-image": {
      border: "2px solid green",
    },
  },
  dropImage: {
    img: {
      borderRadius: "50%",
    },
  },

  camera: {
    position: "absolute",
    // position:'relative',
    // top:'28%',
    // right:'5%',
    marginTop: 75,
    marginLeft: 75,
    background: "#FFBA45",
    borderRadius: "50%",
    padding: 5,
    [`&:hover`]: {
      cursor: "pointer",
    },
  },
}));

export default useStyles;
